export const STATION_TEXT = {
	missingTimestampPlaceholder: 'N/A',
	breakdownBadgeAriaLabel: 'Breakdown location',
	operationalStopLabel: 'Operational stop',
};
